import { apiRequest } from './apiClient';

export const getRatesByTripId = async (tripId) => {
  return apiRequest(`/rates/trip/${tripId}`);
};

export const createRate = async (rateData) => {
  const formattedData = {
    ...rateData,
    assist: !!rateData.assist ? 1 : 0,
    excursions: !!rateData.excursions ? 1 : 0,
  };

  return apiRequest('/rates', { method: 'POST', body: formattedData, modelLabel: 'tarifa' });
};

export const deleteRate = async (rateId) => {
  return apiRequest(`/rates/${rateId}`, { method: 'DELETE', modelLabel: 'tarifa' });
};

export const deleteRatesByTripId = async (tripId) => {
  return apiRequest(`/rates/trip/${tripId}`, {
    method: 'DELETE',
    successMessage: 'Se han eliminado las tarifas correctamente.',
  });
};
// Add more rate-related service methods here as needed
